<template>
    <div class="sidebar">

        <div class="sidebar__link" v-b-modal="'upgrades-modal'" v-b-tooltip.hover.right title="Upgrade Account" boundary="viewport" v-if="clientAccount !='PRO'">
            <i class="fas fa-chart-line upgrade-icon"></i>
        </div>
        
        <div class="sidebar__link" v-b-tooltip.hover.right title="View All Elements" boundary="viewport" @click="showComponent('selectElements')" v-if="showBackToElementsButton">
            <i class="fas fa-th"></i>
        </div>

        <div class="sidebar__link" v-b-tooltip.hover.right title="Access Font Library" boundary="viewport" v-b-modal="'FontLibraryClient'">
            <i class="fas fa-font"></i>
        </div>

        <div class="sidebar__link" v-b-tooltip.hover.right title="Contact Support" boundary="viewport">
            <i class="far fa-envelope"></i>
        </div>

        <div class="sidebar__link" v-b-tooltip.hover.right title="Info Docs" boundary="viewport">
            <i class="fas fa-info-circle"></i>
        </div>

    </div>
</template>

<script>

export default {
    name: 'Sidebar',
    data() {
        return{
            // sidebarLinks: [
            //     // {name: 'View All Apps', link: 'SelectElements', icon: 'fas fa-th'},
            //     {name: 'Access Font Library', modalName: 'FontLibrary', icon: 'fas fa-font'},
            //     {name: 'Upgrade Account', modalName: 'UpgradeAccount', icon: 'fas fa-chart-line'},
            //     {name: 'Contact Support', modalName: 'contactSupport', icon: 'far fa-envelope'},
            //     {name: 'Info Docs', modalName: 'infoDocs', icon: 'fas fa-info-circle'} 
            // ]
        }
    },
    methods: {
        showComponent(component) {
            this.$store.state.weeblySettings.name = component
        },

        showModal(modal) {
            return "'"+modal+"'"
        }
    },
    computed:{
        settingsFromWeebly() {
            return this.$store.state
        },
        showBackToElementsButton() {
            return this.$store.state.showBackToElements
        },
        clientAccount() {
            return this.$store.state.clientInfo.clientAccount
        }
    }
}
</script>

<style lang="less">
@import '../../less/colors.less';

.sidebar {
    background: #fff;
    border-right: 1px solid @border_grey_medium;
    padding: 100px 0 30px;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    z-index: 10;
    width: 75px;
    text-align: center;

    .sidebar__link {
        color: @subtitle_grey;
        line-height: 75px;
        font-size: 1.2em;
        cursor: pointer;
        border-left: 3px solid transparent;

        &:hover {
            color: @action_blue;
            border-color: @action_blue;
        }
    }
}
.upgrade-icon {
    color: @action_orange;
    border: 2px solid @action_orange;
    padding: 5px;
    border-radius: .25rem;
}

</style>




// WEBPACK FOOTER //
// src/components/layout/Sidebar.vue